import loan_1 from "/public/images/icon/loan-1.png";
import loan_11 from "/public/images/icon/loan-11.png";
import loan_2 from "/public/images/icon/loan-2.png";
import loan_22 from "/public/images/icon/loan-22.png";
import loan_3 from "/public/images/icon/loan-3.png";
import loan_33 from "/public/images/icon/loan-33.png";
import loan_4 from "/public/images/icon/loan-4.png";
import loan_44 from "/public/images/icon/loan-44.png";

const planning_data = [
  {
    id: 1,
    icon1: loan_1,
    icon2: loan_11,
    title: "Home Loans",
    dsc_list: ["Lowest interest rates", "Fast Loan Processing"],
  },
  {
    id: 2,
    icon1: loan_2,
    icon2: loan_22,
    title: "Car Loans",
    dsc_list: ["Competitive rates", "Quick Easy"],
  },
  {
    id: 3,
    icon1: loan_3,
    icon2: loan_33,
    title: "Education Loans",
    dsc_list: ["Pay back conveniently", "Fast Loan Processing"],
  },
  {
    id: 4,
    icon1: loan_4,
    icon2: loan_44,
    title: "Business Loans",
    dsc_list: ["Easy Approvals", "Full Assistance"],
  },
];

export default planning_data;
